import { render, staticRenderFns } from "./on-account-manage.vue?vue&type=template&id=15c6b034&scoped=true&"
import script from "./on-account-manage.vue?vue&type=script&lang=ts&"
export * from "./on-account-manage.vue?vue&type=script&lang=ts&"
import style0 from "./on-account-manage.vue?vue&type=style&index=0&id=15c6b034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6b034",
  null
  
)

export default component.exports